import React from "react";
import { LegalLayout } from "./LegalLayout";

const H = ({ children }) => (
  <h2 className="text-lg font-bold tracking-tight pt-2">{children}</h2>
);

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="23 September 2026">
      <p>
        NUMEX is a free, browser-based daily number puzzle. This policy explains what NUMEX
        processes when you play. We keep it minimal — there are no player accounts and no
        sign-up is required.
      </p>

      <H>Anonymous player identifier</H>
      <p>
        When you first play, your browser generates a random anonymous identifier and stores it
        in your browser&apos;s local storage. It is not linked to your name, email, or any
        real-world identity. It exists only so your daily progress and statistics can be saved and
        restored on your device.
      </p>

      <H>Game progress &amp; statistics</H>
      <p>
        We store your progress for the current day&apos;s puzzle (the guesses you submit and the
        resulting feedback), and aggregate statistics tied to your anonymous identifier: games
        played, win percentage, current and best streaks, and your guess distribution. This lets
        the game restore your board after a refresh and show your stats. Your guesses are validated
        on our server, which is why this information is stored server-side against your anonymous id.
      </p>

      <H>Browser (local) storage</H>
      <p>
        NUMEX uses your browser&apos;s local storage to remember your anonymous identifier and
        whether you have seen the &quot;How to Play&quot; intro. Clearing your browser storage will
        reset your local identity and starts you as a new anonymous player.
      </p>

      <H>Timezone</H>
      <p>
        Your browser&apos;s timezone is sent with requests solely to determine which day&apos;s
        puzzle is active for you (NUMEX follows your local calendar day). It is used to serve the
        correct puzzle and is not used to identify you.
      </p>

      <H>Analytics &amp; cookies</H>
      <p>
        We use privacy-conscious product analytics (PostHog) to understand general usage and improve
        NUMEX. This may set cookies or use local storage and may record anonymised usage
        interactions. We do not sell your data. Aside from analytics, NUMEX does not use advertising
        or tracking cookies.
      </p>

      <H>What we do NOT collect</H>
      <p>
        No accounts, no passwords, no email addresses (unless you choose to email us), no payment
        information, and no advertising profiles.
      </p>

      <H>Data retention</H>
      <p>
        Progress and statistics remain associated with your anonymous identifier so the game keeps
        working across visits. You can effectively remove your local identity at any time by
        clearing your browser storage.
      </p>

      <H>Children</H>
      <p>
        NUMEX is a general-audience puzzle and does not knowingly collect personal information from
        children.
      </p>

      <H>Contact</H>
      <p>
        Questions about privacy? Email{" "}
        <a className="underline" href="mailto:hello@playnumex.com">hello@playnumex.com</a>.
      </p>
    </LegalLayout>
  );
}
